<template>
  <v-layout row class="selectable" @click="rowClicked">
    <v-flex xs2 sm1 class="align-self-center">
      <v-icon medium>timelapse</v-icon>
    </v-flex>
    <v-flex xs4 sm3 pr-2 class="align-self-center">
      <v-flex class="prevent-overflow">
        <span v-if="nameBreakType === undefined || nameBreakType === 'both'">
            {{exemption.student.firstName | nameBreak(nameBreakSize)}} {{exemption.student.lastName | nameBreak(nameBreakSize)}}
          </span>
        <span v-else-if="nameBreakType === 'combined'">
            {{combineStudentName | nameBreak(nameBreakSize)}}
          </span>
        <span v-else>
            {{exemption.student.firstName}} {{exemption.student.lastName}}
          </span>
      </v-flex>
      <v-flex class="prevent-overflow">{{getDisplayId | nameBreak}}</v-flex>
    </v-flex>
    <v-flex xs3 sm2 class="align-self-center prevent-overflow" v-if="$vuetify.breakpoint.smAndUp">
      {{exemption.exemptionReason.description}}
    </v-flex>
    <v-flex xs3>
      <v-flex>
        {{exemption.startDate | date}}
      </v-flex>
      <v-flex>
        {{exemption.endDate | date}}
      </v-flex>
      <v-flex class="prevent-overflow" v-if="$vuetify.breakpoint.xsOnly">
        {{exemption.exemptionReason.description}}
      </v-flex>
    </v-flex>
    <v-flex style="position: relative;">
      <v-menu v-if="shouldShowMenu" @click.native.stop lazy top class="tutor-ellipsis-menu">
        <v-btn flat small icon slot="activator" class="ma-0">
          <v-icon>more_horiz</v-icon>
        </v-btn>
        <v-list>
          <v-list-tile @click="editExemption">
            <v-icon class="pr-2">edit</v-icon>
            {{$t('edit')}}
          </v-list-tile>
          <v-list-tile v-if="shouldShowDelete" @click="deleteExemption(exemption.id)">
            <v-icon class="pr-2">delete</v-icon>
            {{$t('delete')}}
          </v-list-tile> 
        </v-list>
      </v-menu>
    </v-flex>

  </v-layout>
</template>

<script>
  import DateFormat from '../../mixins/DateFormat'
  import EditExemption from '../../mixins/EditExemption'
  import NameBreak from '../../mixins/NameBreak'
  import { mapGetters } from 'vuex'
  import { GET_STUDENT_TRUNCATION_SIZE, GET_STUDENT_TRUNCATION_TYPE } from '../../store/getter-types'

  export default {
    name: 'tutor-exemption',
    props: ['exemption'],
    mixins: [DateFormat, EditExemption, NameBreak],
    data () {
      return {}
    },
    methods: {
      rowClicked (value) {
        this.$emit('row-clicked', this.exemption)
      }
    },
    computed: {
      ...mapGetters({
        nameBreakSize: GET_STUDENT_TRUNCATION_SIZE,
        nameBreakType: GET_STUDENT_TRUNCATION_TYPE
      }),
      combineStudentName () {
        return this.exemption.student.firstName + ' ' + this.exemption.student.lastName
      },
      getDisplayId () {
        return this.exemption.student.displayId ? this.exemption.student.displayId : this.exemption.student.studentIdentifier
      }
    },
    watch: {}
  }
</script>

<style scoped>
  .align-self-center {
    align-self: center;
  }

  .selectable {
    cursor: pointer;
  }

  .tutor-ellipsis-menu{
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 32px;
  }
</style>



// WEBPACK FOOTER //
// src/components/intervention/TutorExemption.vue